import { IMAGE_BASEURL } from '@/utils/config/env';

export const modifyCategoryTreeDataHandler = (
  type, // menu or megaMenu
  array,
  parentURL = '',
  parentBreadcrumb = []
) => {
  return (array || [])
    .filter(
      (cat) =>
        cat.is_active &&
        (type === 'menu'
          ? cat.include_in_menu === '1'
          : cat.include_in_mega_menu) &&
        cat.product_count > 0
    )
    .map((cat) => {
      // Set currentURL for each category
      const currentURL = `${parentURL}/${cat.url_key}`;

      // Build up the breadcrumb path
      const breadcrumb = [
        ...parentBreadcrumb,
        {
          name: cat.name,
          url: currentURL,
        },
      ];

      const modifiedCategory = {
        ...cat,
        currentURL,
        breadcrumb,
      };

      // If there are children, apply recursion to include them
      if (cat.children_data?.length) {
        modifiedCategory.children_data = modifyCategoryTreeDataHandler(
          type,
          cat.children_data,
          currentURL,
          breadcrumb
        );
      }

      return modifiedCategory;
    });
};

export const handleFilterArrayToString = (filters) => {
  if (!filters || Array.isArray(filters) === false) return '';

  const sortedFilters = (filters || [])?.sort((a, b) =>
    a?.code?.localeCompare(b?.code)
  );

  let str = '';
  sortedFilters?.forEach((item) => {
    switch (item.type) {
      case 'price':
        str += `&minPrice=${item?.range?.[0]}&maxPrice=${item?.range?.[1]}`;
        break;
      case 'sort':
        str += `&${item?.code}`;
        break;
      case 'filter':
        str += `&${item?.code}=${item?.key}`;
        break;
      default:
    }
  });

  return str.slice(1);
};

function intOrFixedNumber(number) {
  if (isNaN(number)) return null;
  const fixedNumber = number?.toFixed(2);
  const [IntPart, floatPart] = String(fixedNumber)?.split('.');
  return floatPart === '00' ? IntPart : fixedNumber;
}

export const validatePrice = (prices) => {
  let originalPrice = prices?.original_price;
  let specialPrice = null;
  let discount = null;
  let discountPercentage = null;

  specialPrice = prices?.final_price;
  discount = ((originalPrice - specialPrice) / originalPrice) * 100;
  discountPercentage = intOrFixedNumber(
    100 - (specialPrice / originalPrice) * 100
  );
  
  return {
    originalPrice,
    specialPrice,
    final_price: prices?.final_price || 0,
    discount: Number(discount || 0)?.toFixed(0),
    discountPercentage,
  };
};

export const priceFormatedObject = (item) => {
  return {
    discounted_price:
      item?.extension_attributes?.special_price ||
      item?.prices_with_tax?.discounted_price ||
      0,
    original_price:
      item?.extension_attributes?.original_price ||
      item?.prices_with_tax?.original_price ||
      0,
    discounted_price_from:
      item?.extension_attributes?.special_price_from ||
      item?.prices_with_tax?.discounted_price_from,
    discounted_price_to:
      item?.extension_attributes?.special_price_to ||
      item?.prices_with_tax?.discounted_price_to ||
      '',
    final_price: item?.prices_with_tax?.final_price || 0,
    price_incl_tax: item?.price_incl_tax || 0,
  };
};

export const extractCategoryId = (catId) => {
  if (!catId) return null;
  return catId.at(-1)?.split('-c-')?.at(-1);
};
export const getCurrentCategoryName = (categoryData, categoryId) => {
  if (!categoryData?.products || !categoryId) return null;
  return categoryData?.products?.[0]?._category_?.sub_categories.find(
    (c) => c.category_id === categoryId
  )?.name;
};

/**
 * Groups banners by `group_id` and sorts them in ascending order.
 * @param {Array} banners - List of banner objects with a `group_id` property.
 * @returns {Array} - An array of grouped and sorted banner arrays.
 */
export const groupAndSortBanners = (banners) => {
  const grouped = banners.reduce((acc, banner) => {
    (acc[banner.group_id] ||= []).push(banner);
    return acc;
  }, {});

  return Object.values(grouped).sort((a, b) => a[0].group_id - b[0].group_id);
};

/**
 * Splits products into chunks and associates them with grouped banners.
 * @param {Array} products - List of product objects.
 * @param {Array} banners - List of banner objects to be grouped.
 * @param {number} [chunkSize=6] - Number of products per chunk.
 * @returns {Object} - An object containing:
 *   - `chunks`: Array of chunked products with their corresponding banners.
 *   - `bannerCount`: Total number of banner groups.
 */
export const chunkProductsWithBanners = (products, banners, chunkSize = 6) => {
  const groupedBanners = groupAndSortBanners(banners);
  const bannerCount = groupedBanners.length;

  return {
    chunks: Array.from(
      { length: Math.ceil(products.length / chunkSize) },
      (_, i) => ({
        products: products.slice(i * chunkSize, (i + 1) * chunkSize),
        banners: groupedBanners[i] || [],
      })
    ),
    bannerCount,
  };
};

export const prepareFilters = (aggregate = []) => {
  return aggregate.reduce(
    (groupedFilters, { label, filter_key, filterable_values }) => {
      if (!filterable_values?.length) return groupedFilters;

      const filter = {
        title: label,
        code: filter_key,
        list: filterable_values,
      };

      switch (filter_key) {
        case 'categories':
          groupedFilters.categories.push(filter);
          break;
        case 'color':
          groupedFilters.colors.push(filter);
          break;
        default:
          groupedFilters.others.push(filter);
          break;
      }

      return groupedFilters;
    },
    {
      categories: [],
      colors: [],
      others: [],
    }
  );
};

// used in category page
export function validateImgSrc(img) {
  if (img.startsWith('https://')) return img;
  if (img.includes('/media/catalog/category/'))
    return IMAGE_BASEURL + img?.replace('/media', '');
  if (!img.startsWith('/media/catalog/category/'))
    return IMAGE_BASEURL + '/catalog/category/' + img;
  return '';
}
